import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./pages/cn/Home.vue";
import HomeEn from "./pages/en/HomeEn.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    // mode: "hash",
    mode: 'history',
    // base: process.env.BASE_URL,
    routes: [{
            path: '*',
            component: Home
        },
        {
            path: "/cn",
            name: "Home",
            component: Home
        },
        {
            path: "/en",
            name: "HomeEn",
            component: HomeEn
        },
    ]
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

export default router;


// WEBPACK FOOTER //
// ./src/router.js